import React, { useState } from 'react';
import { cn } from './cn';

/** Unboxed media navigation; callers provide content and its action. */
export default function MediaCard({ title, thumbnail, label, icon: Icon, className, ...props }) {
  const [failedSource, setFailedSource] = useState(null);
  return (
    <button
      type="button"
      className={cn(
        'group block w-full min-w-0 min-h-11 p-0 border-0 bg-transparent text-left font-instrument text-bun-text rounded-bun-lg cursor-pointer',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bun-blue focus-visible:ring-offset-2 focus-visible:ring-offset-bun-canvas',
        className
      )}
      {...props}
    >
      <span className="relative flex aspect-video w-full items-center justify-center overflow-hidden rounded-bun-lg bg-bun-mist-deep group-hover:bg-bun-mist">
        {thumbnail && failedSource !== thumbnail ? (
          <img src={thumbnail} alt="" className="absolute inset-0 h-full w-full object-cover" onError={() => setFailedSource(thumbnail)} />
        ) : Icon ? (
          <Icon className="h-7 w-7 text-bun-faint" aria-hidden="true" />
        ) : null}
      </span>
      <span className="mt-2 block text-bun-label font-semibold uppercase tracking-wide text-bun-stone">{label}</span>
      <span className="mt-0.5 block text-bun-body font-strong leading-snug line-clamp-2">{title}</span>
    </button>
  );
}
